var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelledBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_987_2473)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_2473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C15.0294 11 11 15.0294 11 20C11 24.9706 15.0294 29 20 29C24.9706 29 29 24.9706 29 20C28.9946 15.0316 24.9684 11.0054 20 11ZM23 21.9402C23.3048 22.2207 23.3244 22.6952 23.0439 23C22.7634 23.3048 22.289 23.3244 21.9842 23.0439C21.9689 23.0299 21.9543 23.0152 21.9402 23L20 21.0605L18.0605 23C17.7626 23.2877 17.2878 23.2795 17 22.9815C16.7193 22.6909 16.7193 22.2301 17 21.9395L18.9395 20L17 18.0605C16.7123 17.7626 16.7205 17.2878 17.0185 17C17.3091 16.7193 17.7699 16.7193 18.0605 17L20 18.9395L21.9402 17C22.2207 16.6952 22.6952 16.6756 23 16.9561C23.3048 17.2366 23.3244 17.711 23.0439 18.0158C23.0299 18.0311 23.0152 18.0457 23 18.0598L21.0605 20L23 21.9402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_2473",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA37C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_2473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledBanner);
export default __webpack_public_path__ + "static/media/cancelled_banner.aa317dc2d7c3ef3ac6454d2333ccf04f.svg";
export { ForwardRef as ReactComponent };